import { createFileRoute } from '@tanstack/react-router';

type Search = {
  demo?: boolean;
  payment?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/quotes_/$quoteId')({
  staticData: { team: 'fe-clm' },
  validateSearch: (search: Search): Search => {
    return {
      demo: search.demo,
      payment: search.payment,
    };
  },
});
